type SetWalletInputProps = {
  currency_name: string
  wallet?: string
}

export const SetWalletInput = ({ currency_name, wallet }: SetWalletInputProps) => {
  return (
    <div className="aplication-form__row d-flex flex-column justify-content-between first-of-type:mt-4">
      <label className="label">{currency_name}</label>
      <div className="d-flex">
        <input type="text" className="w-full input mr-0 xs:mr-10" defaultValue={wallet} disabled />
        {/* <button className="button button-sm button-green">Save</button> */}
      </div>
    </div>
  )
}
